<template>
  <div class="container d-flex justify-content-center align-items-center py-5">
    <div style="width: 100%; max-width: 500px">
      <!-- Login Form -->
      <div class="card shadow rounded p-4" v-if="!showInfo">
        <div class="card-body">
          <h4 class="text-center mb-3">Login</h4>
          <div class="mb-3">
            <label for="username" class="form-label">Username (ID)</label>
            <input type="text" class="form-control" id="username" v-model="form.username" readonly
              :class="{ 'is-invalid': idInvalid }" />
            <div class="invalid-feedback">This ID is not found</div>
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <input type="password" class="form-control" id="password" v-model="form.password"
              :class="{ 'is-invalid': passwordInvalid }" />
            <div class="invalid-feedback">Please enter your password</div>
          </div>
          <button class="btn btn-purple w-100" @click="handleLogin">Login</button>
        </div>
      </div>

      <!-- Info Card -->
      <div class="card shadow rounded p-2 mt-1" v-if="showInfo">
        <h4 class="text-center mb-1">Detail</h4>
        <div class="card-body">
          <h6 class="card-title mb-1">Name : {{ currentUser.prefix }} {{ currentUser.firstname }} {{
            currentUser.lastname }}</h6>
          <p class="mb-1">ID Card No. : {{ currentUser.username }}</p>
          <p class="mb-1">Sex : {{ currentUser.gender }}</p>
          <p class="mb-1">Nationality : {{ currentUser.nationality }}</p>
          <p class="mb-1">CenterName : {{ currentUser.centerName }}</p>
          <p class="mb-1">Appointment Date : {{ currentUser.registeredExitDate }}</p>
          <p class="mb-1">Shift : {{ currentUser.shift }}</p>
          <p class="mb-1">StationName : {{ currentUser.stationName }}</p>
          <p class="mb-1">Profile Image :</p>
          <div v-if="profilePreview" class="text-center mt-2">
            <img :src="profilePreview" alt="Preview" style="max-width: 150px; border-radius: 10px;">
          </div>
          <div v-else class="text-muted" style="font-style: italic;">
            Not Image
          </div>
        </div>
        <p class="mb-1">Status : </p>
        <!-- <b-table v-if="currentUser.statusGroups" :items="currentUser.statusGroups" :fields="tableFields" bordered
          small></b-table> -->

        <b-table v-if="currentUser.statusGroups" :items="currentUser.statusGroups" :fields="tableFields" bordered small>
          <template #cell(status)="data">
            <span :style="getStatusColor(data.item.status)">
              {{ data.item.status }}
            </span>
          </template>
        </b-table>

      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import axios from "axios";
import API from "@/connect/config";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
export default {
  name: "LoginQueue",
  mixins: [togglePasswordVisibility],

  data() {
    return {
      form: {
        username: '',
        password: '',
        startDate: '',
        endDate: '',
      },
      passwordInvalid: false,
      idInvalid: false,
      showInfo: false,
      profilePreview: null,
      currentUser: {},
      users: [
        {
          id: "0000000000001",
          name: "MR.WANCHART SUDHIWAN",
          sex: "Male",
          nationality: "Thai",
          appointmentDate: "01/08/2568 09:00"
        },
        {
          id: "0000000000002",
          name: "MS.SUDA WANIT",
          sex: "Female",
          nationality: "Myanmar",
          appointmentDate: "02/08/2568 13:30"
        },
        {
          id: "0000000000003",
          name: "MR.SOMCHAI DEE",
          sex: "Male",
          nationality: "Myanmar",
          appointmentDate: "03/08/2568 10:00"
        },
        {
          id: "0000000000004",
          name: "MRS.LADA CHAIYASIT",
          sex: "Female",
          nationality: "Thai",
          appointmentDate: "04/08/2568 14:15"
        },
        {
          id: "0000000000005",
          name: "MR.NAY WIN",
          sex: "Male",
          nationality: "Myanmar",
          appointmentDate: "05/08/2568 08:45"
        }
      ],
      statusGroups: [],
      tableFields: [
        { key: "category", label: "หมวดหมู่" },
        { key: "status", label: "สถานะ" }
      ]
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("prm1");
    const startDate = params.get("prm2");
    if (id) {
      this.form.username = id;
      this.form.startDate = startDate;
      this.form.endDate = startDate;
    }
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case "อนุมัติ":
        case "ผ่าน":
        case "สำเร็จ":
          return { color: "#28a745", fontWeight: "bold" }; // เขียว
        case "ไม่อนุมัติ":
          return { color: "#dc3545", fontWeight: "bold" }; // แดง
        case "ยกเลิก":
          return { color: "#6c757d", fontWeight: "bold" }; // เทา
        default:
          return { color: "#ffc107", fontWeight: "bold" }; // เหลือง
      }
    },
    async handleLogin() {

      this.passwordInvalid = this.form.password.trim() === '';
      //  const user = this.users.find(u => u.id === this.form.username);
      // this.idInvalid;
      if (!this.passwordInvalid) {
        const user = await this.Login();  // ✅ รับค่าจาก Login
        // await getDataTable();
        //this.currentUser = user;          // ✅ set currentUser จากค่าที่ return
      }
      if (this.passwordInvalid || this.idInvalid) {
        console.log("Login failed", this.form);
      }
    },
    async Login() {
      console.log("Logging in with", this.form);

      await axios
        .post(`${API}login`, {
          username: this.form.username,
          password: this.form.password,
        })
        .then(async (res) => {
          console.log(res.data.message.refresh_token);

          localStorage.setItem("refresh_token", res.data.message.refresh_token);

          let jwt = await this.$store.dispatch(
            "getJwtDecode",
            res.data.message.refresh_token
          );

          localStorage.setItem("company_jwt", JSON.stringify(jwt));

          //  console.log(jwt);
          if (res.data.status == 200) {
            console.log("เข้าสู่ระบบสำเร็จ");
            this.showInfo = true;
            await this.getDataTable();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "เข้าสู่ระบบสำเร็จ",
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${res.data.message}`,
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.message}`,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });

    },
    async getDatauserFromCompany(_userId) {
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          companyId: jwt.companyId,
          userId: _userId,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}userFromCompany`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data)
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }

      return;

    },
    formatDateFromYYYYMMDD(dateStr) {
      if (!dateStr || dateStr.length !== 8) return "";
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${day}-${month}-${year}`;
    },
    async getImage() {
      console.log("this.currentUser.image", this.currentUser);
      try {
        const res = await axios.get(
          `${API}files/image/${this.currentUser.image[0]}`,
          {
            responseType: "arraybuffer", // สำคัญ!
            headers: {
              Authorization: await store.dispatch("getAuthorization"), // ใช้ refreshToken จาก JWT
            }
          }
        );
        console.log("res.data", res.data);

        // ดึง MIME Type จาก header ถ้าไม่มีใช้ jpeg เป็นค่า default
        const mimeType = res.headers["content-type"] || "image/jpeg";

        const blob = new Blob([res.data], { type: mimeType });
        this.profilePreview = URL.createObjectURL(blob);

        console.log("โหลดรูปสำเร็จ");
      } catch (err) {
        console.error("โหลดรูปไม่ได้", err);
      }
    },
    async getDataTable() {

      // ตัวอย่างดึงข้อมูลจาก store (หรือ API)
      console.log("Fetching user data...");
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        console.log(this.form.startDate, this.form.endDate);
        console.log("User ID:", jwt.userId);


        let params1 = {
          userId: jwt.userId, //68ba5fecafbd84a0833140a0
          includeCompany: 'false',
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          _page: 1,
          _limit: 100,
          _sort: "-1",
          IdCode: this.form.username.trim() || undefined, // ใช้ username จากฟอร์ม
        };

        console.log("Request Params", params1);
        const res1 = await axios.get(`${API}entry?userId=${jwt.userId}&includeCompany=false&startDate=${this.form.startDate}&endDate=${this.form.startDate}&IdCode=${this.form.username}&_page=1&_limit=15&_sort=1&status=all`, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log(res1.data.message.data);


        const results = await Promise.all(
          res1.data.message.data.map(async (item, index) => {
            const datausername = await this.getDatauserFromCompany(item.userId);

            let statusGroups = [];
            console.log("Processing Status:", item.processingStatus);
            if (item.processingStatus) {
              try {
                const parsed = JSON.parse(item.processingStatus); // ได้เป็น array
                if (Array.isArray(parsed) && parsed.length > 0) {
                  // รวมทุก object เข้าด้วยกัน
                  statusGroups = parsed.flatMap(obj =>
                    Object.entries(obj).map(([category, status]) => ({
                      category,
                      status
                    }))
                  );
                }
              } catch (e) {
                console.error("Error parsing processingStatus:", e);
              }
            }
            console.log("Status Groups:", statusGroups);
            return {
              ...item,
              statusGroups, // ✅ เก็บไว้ใน item
              registeredEntryDateFormatted: this.formatDateFromYYYYMMDD(item.registeredEntryDate),
              registeredExitDateFormatted: this.formatDateFromYYYYMMDD(item.registeredExitDate),
              prefix: datausername ? datausername.prefix : "",
              firstname: datausername ? datausername.firstname : "",
              lastname: datausername ? datausername.lastname : "",
              gender: datausername ? datausername.gender : "",
              nationality: datausername ? datausername.nationality : "",
              username: datausername ? datausername.username : "",
              registeredExitDate:
                dayjs(item.registeredExitDate).isValid()
                  ? dayjs(item.registeredExitDate).format("DD/MM/YYYY")
                  : "",
              image: datausername ? datausername.image : "",
            };
          })
        );

        console.log("Processed Results:", results);
        this.currentUser = results[0] || {};

        if (this.currentUser.image[0] != undefined && this.currentUser.image[0] != null) {
          this.profilePreview = null;
          await this.getImage();
          this.isBusy = true;
        } else {
          this.profilePreview = null;
        }
        return;

      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
      return;
    },
  }
};
</script>

<style scoped>
.btn-purple {
  background-color: #887EF2;
  color: white;
}

.btn-purple:hover {
  background-color: #5a32a3;
}
</style>
